import type { Size } from '@/types';

export const DEFAULT_NOTE_SIZE: Size = Object.freeze({ width: 240, height: 160 });
export const DEFAULT_WINDOW_SIZE: Size = Object.freeze({ width: 420, height: 320 });
export const MIN_OBJECT_SIZE: Size = Object.freeze({ width: 80, height: 48 });
export const GRID_SIZE = 8;
/** Screen-pixel distance within which edges, centres and grid lines attract a dragged object. */
export const SNAP_TOLERANCE_PX = 6;
/** Screen-pixel distance within which a connection line can be clicked. */
export const CONNECTION_HIT_PX = 7;
